<div class="container-fluid d-flex p-0">
    <app-side-bar></app-side-bar>
  
    <!-- Header Block -->
    <div class="container-fluid">
      <div class="container-fluid my-3">
        <div class="top-card">
          <div class="row w-100 mx-auto d-flex  ">
            <div class="col-sm-12 col-md-12 col-lg-9 pl-4">
              <!-- <img class="logo-top" src="../../assets/images/logo-M (1).png"> -->
              <span class="">UserPortfolio Management Suite</span>
            </div>
          </div>
        </div>
      </div>
      <div class="card" style="margin: 10px;border-radius: 10px;">
  
        <div class="">
          <div class="row">
            <div class="col-2 col-md-2 col-sm-12" style="margin: 10px;">
                <p-dropdown [options]="userModuleList" [(ngModel)]="userSelectedModule" autoWidth="false"
                  [style]="{'width':'90%','font-size':'12px'}" optionLabel="name" placeholder="Select User"
                   (ngModelChange)="userSelectedModuleChange()">
                </p-dropdown>
              </div>
            
            <div class="col-1 col-md-2 col-sm-12" style="margin: 10px;">
              <p class="my-auto ml-3" style="font-size: 20px;font-weight: 600;">Enter The Molecule</p>
            </div>
  
            <div class="col-3 col-md-3 col-sm-12" style="margin: 10px;">
              <i class="fa fa-search icon" style="margin-right: 10px;"></i>
              <input class="w-75" placeholder="Enter the Molecule Name" [(ngModel)]="searchValue"
                (keydown.enter)="searchMolecule()" autofocus>
            </div>
  
            <div class="col-1 col-md-1 col-sm-12" style="margin: 10px;">
              <button type="button" class="btn btn-light" (click)="searchMolecule()">Submit</button>
            </div>
            <div class="col-2 col-md-2 col-sm-12" style="margin: 10px;">
              <p-dropdown [options]="submolecules" [(ngModel)]="selectedSubMolecule" autoWidth="false"
                [style]="{'width':'90%','font-size':'12px'}" optionLabel="name" placeholder="Select NDA"
                (ngModelChange)="getData()" *ngIf="subMolecule">
              </p-dropdown>
            </div>

        
    
  
            <div class="col-1 col-md-1 col-sm-12" style="margin: 10px;">
              <button type="button" class="btn btn-light" (click)="clearFilter()">Clear</button>
            </div>
  
          </div>
        </div>
      </div>
  
      <p-tabView *ngIf="selectedSubMolecule && clearData">
        <p-tabPanel header="Business Case">
          <div class="app-business-case-setting" style="padding: 2rem; margin-left: 1rem;">
            <app-business-case-setting [needRefresh]="needRefresh" [apiCost]="apiCost"
              [MolData]="selectedSubMolecule['code']" [callUserEmail]="userSelectedModule"></app-business-case-setting>
          </div>
  
        </p-tabPanel>
  
      </p-tabView>
    </div>
  </div>